import {init} from 'iqos-mw';
import {useEffect} from 'react';

import log from '@/services/logger/log';
import userBrowserService from '@/services/user/userBrowserService';

const useIqosMw = () => {
    const userAgent = userBrowserService.getUserAgent();
    const sdkConfig = {
        userAgent,
        log,
    };

    useEffect(() => {
        init(sdkConfig);
    }, []);
};

export default useIqosMw;
